// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__kPxmZ","bigColWidth":"Table_bigColWidth__zX5Ev","biggerColWidth":"Table_biggerColWidth__2wQHi","row":"Table_row__1rRPT","col":"Table_col__2sTcc"};